import { LastMinuteRiskAnalysis } from "@/services/backend/vbs/work-orders/types/last-minute-risk-analysis";
import {
  updateVbsLMRACache,
  useVbsLMRAResetReferenceNumberMutation,
  useVbsLMRAPatchMutation,
} from "@/services/backend/vbs/work-orders/api/lmra-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { Card, CardContent } from "@/shared/components/ui/card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

/**
 * LMRAReferenceNumberCard edits the reference number of a last minute risk
 * analysis.
 *
 * The analysis is a document of its own, rendered inside the page of its
 * work order. Its errors get a scope of their own, so they do not collide
 * with the work order's "referenceNumber".
 */
export function LMRAReferenceNumberCard({
  lmra,
  disabled = false,
}: {
  lmra: LastMinuteRiskAnalysis;
  disabled?: boolean;
}) {
  const patchReferenceNumber = useVbsLMRAPatchMutation();
  const resetReferenceNumber = useVbsLMRAResetReferenceNumberMutation();

  return (
    <Card>
      <CardContent>
        <ErrValidationFailedContextProvider>
          <ReferenceNumberField
            data={lmra}
            updateCache={updateVbsLMRACache}
            patchMutation={patchReferenceNumber}
            resetMutation={resetReferenceNumber}
            disabled={disabled || isImmutable(lmra)}
          />
        </ErrValidationFailedContextProvider>
      </CardContent>
    </Card>
  );
}
